// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"36054d7954fbb57789dd","293":"a77a96814221f5a087fd","518":"5951d84a7e6409172723","779":"87eefee39901baf78b51"}[chunkId] + ".js";
};